export default __webpack_public_path__ + "static/media/209.3e585508.jpg";